import { Skeleton } from "../ui/skeleton";

export const AssetCardSkeleton = () => {
  return (
    <div className="flex flex-col h-full rounded-2xl overflow-hidden bg-card border border-border">
      <div className="relative aspect-[4/3] overflow-hidden">
        <Skeleton className="absolute inset-0 rounded-none" />
        <div className="absolute top-3 left-3">
          <Skeleton className="h-6 w-16 rounded-full" />
        </div>
        <div className="absolute inset-x-0 bottom-0 p-4 space-y-2">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-3 w-1/2" />
        </div>
      </div>
      <div className="grid grid-cols-3 divide-x divide-border border-b border-border">
        {[0, 1, 2].map((key) => (
          <div key={key} className="p-4 space-y-2">
            <Skeleton className="h-3 w-12" />
            <Skeleton className="h-5 w-14" />
          </div>
        ))}
      </div>
      <div className="mt-auto">
        <Skeleton className="h-[3px] w-full rounded-none" />
        <div className="flex items-center justify-between px-4 py-3">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-3 w-12" />
        </div>
      </div>
    </div>
  );
};
